import { Component, OnInit, Input } from '@angular/core';
import { ModalController, ToastController } from '@ionic/angular';
import { Zoom } from '@ionic-native/zoom/ngx';

@Component({
  selector: 'app-accet-or-decline-call',
  templateUrl: './accet-or-decline-call.component.html',
  styleUrls: ['./accet-or-decline-call.component.scss'],
})
export class AccetOrDeclineCallComponent implements OnInit {
@Input() params;
ToastPosition: any;
ToastTime: number;
ViewToast: boolean;
SDK_KEY = 'wYnserXbZv7e2pdh1R8X9hZTGsRGeWNSCQwe'; 
SDK_SECRET = '2R8BpTK4lAiykr91PKjiVliPxe4BeRqNpMyA';
Inicialized;
color = ' #ff5733';
head = {
    title: 'Llamada entrante',
    imageUrl: 'assets/imgs/phone.gif',
    doctor: '',
  }
;

  constructor(
    private modalController: ModalController,
    private zoomService: Zoom,
    private toastCtrl: ToastController) { }

  ngOnInit() {
    console.log(this.params);
    console.log(this.params.To.FullName);
    this.head.doctor = this.params.To.FullName;
    this.InicializeZoom();
  }

  decline() {
     this.modalController.dismiss();
  }

  InicializeZoom() {
    this.SDK_KEY = !this.SDK_KEY ? '' : this.SDK_KEY;
    this.SDK_SECRET = !this.SDK_SECRET ? '' : this.SDK_SECRET;
    return new Promise((resolve, reject) => {
        if (!this.Inicialized) {
            this.zoomService.initialize(this.SDK_KEY, this.SDK_SECRET)
                .then((success) => {
                  this.Inicialized = true;
                  this.presentToast(success);
                  resolve();
                })
                .catch((err) => {
                  console.error(err)
                  this.presentToast(err);
                  reject(err);
                });
        } else {
            resolve();
        }

    });
}
  accept() {
this.joinMeeting();
  }
   /**
   * Join a meeting, Users Logged and NonLogged
   */
  joinMeeting() {
    const options = {
      no_driving_mode: true,
      no_invite: true,
      no_meeting_end_message: true,
      no_titlebar: false,
      no_bottom_toolbar: false,
      no_dial_in_via_phone: true,
      no_dial_out_to_phone: true,
      no_disconnect_audio: true,
      no_share: true,
      no_audio: true,
      no_video: true,
      no_meeting_error_message: true
    };
    this.zoomService.joinMeeting(this.params.To.MeetingNumber, this.params.To.MeetingPassword, 'Paciente', options)
      .then((success) => {
        this.presentToast(success);
        this.modalController.dismiss();
      }).catch((err) => {
        console.error(err)
        this.presentToast(err);
      });
  }
  async presentToast(text) {
    if (this.ViewToast) {
      this.ToastPosition = this.ToastPosition ? this.ToastPosition : 'top';
      this.ToastTime = this.ToastTime ? this.ToastTime : 3000;
      const toast = await this.toastCtrl.create({
        message: text,
        duration: this.ToastTime,
        position: this.ToastPosition
      });
      toast.present();
    }

  }
}
